import { render, staticRenderFns } from "./RedirectButton.vue?vue&type=template&id=7b2b27f0&scoped=true"
import script from "./RedirectButton.vue?vue&type=script&lang=js"
export * from "./RedirectButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b27f0",
  null
  
)

export default component.exports